import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/styles/btn-styles.css';
import '../src/assets/styles/form-styles.css';
import '../src/assets/styles/table-styles.css';
import '../src/assets/styles/modal-styles.css';
import '../src/assets/styles/file-upload-styles.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import LandingPageLayout from './layouts/LandingPageLayout';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={<LandingPageLayout/>}
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();